import type { SecretResource as SecretResourceModel } from '@/adapters/catalogv1.g';

export function extractSecretResource(model: SecretResourceModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    secretRef: model.secret_ref ?? '',
    resourceRef: model.resource_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogSecretResource = ReturnType<typeof extractSecretResource>;
